import { headers } from "../../../config/config";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { request } from "../api";
import { MESSAGE } from "../../../constants/api/message";

const initialRoute = "providers";
const { Authorization, Bearer } = AUTHORIZATION;

const { post } = request;

export const addProviders = async (_payload: any, group_number: string) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/add-providers?group_number=${group_number}`;
		const token = localStorage.getItem("@jwt");

		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (error: any) {
		throw error;
	}
};
